<template>
  <form
    enctype="multipart/form-data"
    novalidate
    @dragover.prevent
    @drop.prevent="handleChange($event.dataTransfer.files)"
  >
    <div class="columns is-multiline">
      <div
        v-show="files.length == 0"
        class="column is-12 has-text-centered content"
      >
        <slot v-if="files.length == 0"></slot>

        <div v-if="files.length == 0" class="file is-centered" :class="[css]">
          <label class="file-label">
            <input
              type="file"
              :multiple="multiple"
              :name="fieldName"
              :disabled="false"
              accept=".exe, .msi, .nupkg"
              class="file-input"
              @change="handleChange($event.target.name, $event.target.files)"
            />
            <span class="file-cta">{{ btnName }}</span>
          </label>
        </div>

        <div v-if="files.length != 0 && !hideSave" class="buttons is-centered">
          <button
            class="button is-centered"
            :class="[css, { 'is-loading': isLoading }]"
            @click.prevent="!isLoading ? save() : false"
          >
            Spara
          </button>
        </div>
      </div>

      <div v-if="files.length != 0 && !isLoading" class="column is-12">
        <div class="columns is-multiline">
          <a
            v-for="(file, index) in files"
            :key="index"
            class="column is-12"
            @click="
              handleRemove(file);
              $emit('ready', null);
            "
          >
            <span class="icon is-medium middle is-size-5">
              <i class="mdi mdi-package"></i>
            </span>
            {{ file.fullName }}
          </a>
        </div>
      </div>
    </div>
  </form>
</template>

<style lang="css">
.inline {
  display: inline-block;
}
</style>

<script>
import { post, postApi } from "@/utils/http";

export default {
  components: {},
  props: {
    css: String,
    btnName: String,
    uid: String,
    path: String,
    multiple: Boolean,
    format: String,
    hideSave: Boolean,
    data: Object
  },
  data() {
    return {
      files: [],
      fieldName: "file",
      isLoading: false,
      procentDone: 0
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    async save(data) {
      try {
        this.$emit("upload", true);

        this.isLoading = true;
        const files = [...this.files];
        let count = 0;

        for (const file of files) {
          count = count + 1;

          Object.keys(data).map(key => {
            file.formData.set(key, data[key]);
          });

          const result = await post(this.path, file.formData, {
            onUploadProgress: e => this.handleProgress(e.total, e.loaded)
          });
          this.handleRemove(file);

          this.$emit("completed", result);
        }
      } catch (err) {
        this.$emit("error", err);
      }

      this.$emit("upload", false);

      this.isLoading = false;
      this.procentDone = 0;
    },
    async handleChange(fieldName, fileList) {
      try {
        this.isLoading = true;
        let count = 0;
        const total = fileList.length;

        const formData = new FormData();

        for (const file of fileList) {
          count += 1;

          this.procentDone = (100 / total) * count;

          formData.append(fieldName, file, file.name);

          this.files.push({
            formData: formData,
            size: file.size,
            fullName: file.name,
            name: file.name.split(".").shift(),
            ext: file.name
              .toLowerCase()
              .split(".")
              .pop()
          });
        }

        this.isLoading = false;
        this.procentDone = 0;

        this.$emit("ready", this.files[0]);
      } catch (err) {
        console.log(err);
      }
    },
    handleProgress(total, current) {
      this.$emit("progress", (current / total) * 100);
    },
    handleRemove(file) {
      const index = this.files.findIndex(x => x == file);
      this.$delete(this.files, index);
    },
    reset() {
      this.files = [];
    }
  }
};
</script>
